<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <g id="ic_user" transform="translate(0)">
    <g id="Group_75" data-name="Group 75" transform="translate(0)">
      <path id="Path_63" data-name="Path 63" d="M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z" fill="#e6e6e6"/>
    </g>
    <g id="Group_363" data-name="Group 363" transform="translate(5.999 6)">
      <g id="Group_359" data-name="Group 359" transform="translate(0)">
        <g id="Group_318" data-name="Group 318" transform="translate(0)">
          <g id="Group_3" data-name="Group 3">
            <path id="Path_14" data-name="Path 14" d="M31.935,51.7a4.728,4.728,0,0,0-1.284-1.484,6.1,6.1,0,0,0-1.916-1c-.021,0-.042-.021-.063-.021a2.9,2.9,0,0,1-4.547,0c-.021,0-.042.021-.063.021a6.336,6.336,0,0,0-1.916,1A4.507,4.507,0,0,0,20.863,51.7a7.966,7.966,0,0,0-.463,2.65h12A7.027,7.027,0,0,0,31.935,51.7Z" transform="translate(-20.4 -42.351)" fill="#fff"/>
            <ellipse id="Ellipse_5" data-name="Ellipse 5" cx="3.029" cy="3.585" rx="3.029" ry="3.585" transform="translate(2.991)" fill="#fff"/>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
